// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"182":"42e7eded","279":"35601d22"}[chunkId] + ".chunk.css";
};